export default "__VITE_ASSET__DfP4rvmt__"